import { AxiosResponse } from 'axios-cad-nx';
import {
    ApiResultAssociateEventsResponse,
    EventAutocompleteView,
    EventResource,
} from '@mark43/cad-api';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { useApiClient } from '@m43/core';
import { AssociateEntityFormDisplayType } from '../components/associate-entity-form';

interface CopyCallApi {
    associateEvent(data: AssociateEntityFormDisplayType): void;
    mutation: UseMutationResult<
        AxiosResponse<ApiResultAssociateEventsResponse, unknown>,
        unknown,
        AssociateEntityFormDisplayType,
        unknown
    >;
}

export function useAssociateEventsApi(
    agencyEventId: number,
    onSuccess: (...args: unknown[]) => unknown
): CopyCallApi {
    const apiClient = useApiClient();

    const mutation = useMutation(
        ['associate-event', agencyEventId],
        (form: AssociateEntityFormDisplayType) => {
            return apiClient.request<EventResource.AssociateEventsV2>({
                method: 'POST',
                url: 'event/associate',
                data: {
                    associatedAgencyEventIds: form.associatedEntities.map(
                        (field) => (field as EventAutocompleteView).agencyEventId
                    ),
                    parentAgencyEventId: agencyEventId,
                    reason: form.reason,
                },
            });
        },
        {
            onSuccess() {
                onSuccess();
            },
        }
    );

    const { mutate } = mutation;

    function associateEvent(data: AssociateEntityFormDisplayType): void {
        mutate(data);
    }

    return {
        mutation,
        associateEvent,
    };
}
